module.exports = __webpack_public_path__ + "static/woman-green-smoothie.645bc577.jpg";